import { can, isRole, type Permission, type Role } from "@erp/shared";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { api, unwrap } from "./api";

export interface SessionUser {
  id: string;
  name: string;
  email: string;
  role: Role;
  twoFactorEnabled: boolean;
}

export const meQuery = queryOptions({
  queryKey: ["me"],
  queryFn: async (): Promise<SessionUser> => {
    const me = await unwrap(api.me.get());
    // Never a default role: menus and permissions of another profile would be shown (the API refuses it too).
    if (!isRole(me.role)) throw new Error(`Unknown role: ${me.role}`);
    return { ...me, role: me.role };
  },
  staleTime: 5 * 60_000,
});

export function useSession() {
  return useSuspenseQuery(meQuery).data;
}

export function useCan() {
  const user = useSession();
  return (permission: Permission) => can(user.role, permission);
}
